<template>
  <ElForm class="ghost-button-styles" ref="formRef" label-width="120px" @submit.native.prevent :model="formData" :rules="rules">
    <ElFormItem :prop="isAdd ? 'labels' : 'label'" label="标签名称">
      <ElInput v-if="isAdd" v-model="formData.labels" type="textarea" rows="5" placeholder="请输入标签名称" style="width: 100%"> </ElInput>
      <ElInput v-else v-model="formData.label" style="width: 100%"> </ElInput>
    </ElFormItem>

    <ElFormItem prop="parentId" label="父级标签">
      <el-cascader
        style="width: 100%"
        clearable
        filterable
        v-model="formData.parentIds"
        :show-all-levels="false"
        :props="{ label: 'content', value: 'labelId', checkStrictly: true }"
        :options="treeData"
        @change="onParentLabelChange"
      >
      </el-cascader>
    </ElFormItem>

    <ElFormItem label="游戏组">
      <el-select v-model="formData.gameGroupId" style="width: 100%" @change="onGameGroupChange" filterable placeholder="请选择">
        <el-option v-for="item in gameGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </ElFormItem>

    <ElFormItem label="游戏">
      <el-select v-model="formData.gameIds" style="width: 100%" multiple collapse-tags filterable clearable placeholder="请选择">
        <el-option v-for="item in games" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
    </ElFormItem>

    <ElFormItem prop="labelDesc" label="标签描述">
      <ElInput v-model="formData.labelDesc" type="textarea" rows="5" placeholder="标签描述" style="width: 100%"> </ElInput>
    </ElFormItem>

    <ElFormItem prop="labelDesc" label="状态">
      <el-radio-group v-model="formData.aiEnable">
        <el-radio-button ghost :label="1">启用</el-radio-button>
        <el-radio-button ghost :label="0">停用</el-radio-button>
      </el-radio-group>
    </ElFormItem>
  </ElForm>
</template>

<script setup>
import { ref, computed } from 'vue'
import { getSysTag } from '@/api/common.model.js'
import { initPageData, GAMES, GAME_GROUPS } from '@/data/global-opts'
import { FORM_TYPE, LABEL_TYPES, LEVEL_TYPES } from '../../const'
import { getAiTagRules } from './tag-form-rules.js'
// 当前页面需要的下拉数据项
const PAGE_REQUIRED_OPTS = initPageData([GAMES, GAME_GROUPS])
const gameGroups = computed(PAGE_REQUIRED_OPTS.GAME_GROUPS)
const games = computed(PAGE_REQUIRED_OPTS.GAMES)
const formRef = ref(null)
// eslint-disable-next-line
const props = defineProps({
  formType: {
    type: String
  },
  treeData: {
    type: Array
  }
})

const parentLabels = ref([])

const initFormFields = () => {
  return {
    labels: '',
    // level: 1, // 更新时的model,只能一个更新
    parentIds: [],
    parentId: '',
    gameGroupId: '',
    gameIds: [],
    labelDesc: '',
    aiEnable: 1
  }
}

const formData = ref(initFormFields())
const rules = getAiTagRules(formData)

const isAdd = computed(() => props.formType === FORM_TYPE.ADD)
const isUpdate = computed(() => props.formType === FORM_TYPE.UPDATE)

const onGameGroupChange = (groupId) => {
  const item = gameGroups.value.find((group) => group.id === groupId)
  if (item?.gameIds) {
    formData.value.gameIds = item.gameIds.map(Number)
  }
}

const onParentLabelChange = (value) => {
  if (value) {
    formData.value.parentId = value[value.length - 1] || ''
  }
}

// eslint-disable-next-line
defineExpose({
  validate: () => {
    return new Promise((resolve, reject) => {
      formRef.value.validate((valid) => {
        if (valid) {
          resolve()
        } else {
          reject(new Error('表单验证失败'))
        }
      })
    })
  },
  getForm: () => formData.value,
  setForm: (data) => {
    formData.value = data
  },
  resetForm: () => {
    formData.value = initFormFields()
  }
})
</script>

<style lang="scss" scoped></style>
